import React, {useEffect} from "react";
import { Box, Container, Grid, Paper } from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import { useParams } from "react-router-dom";
import ItemDetailViewSection from "../../../common/item/ItemDetailViewSection";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";
import { getById } from "../../../store/usergroup/queries";
import { Data } from "../../../store/usergroup/types";
import {fetchRequest as fetchPermission} from "../../../store/permission/actions";

const UserGroupView = () => {
  const classes = pageStyles();
  const session = useSession();
  const dispatch = useDispatch();

  const { id } = useParams<{ id: string }>();
  const userGroup = useSelector(id ? getById(id) : () => null) as Data;
  const { attributes: at } = userGroup;

  useEffect(() => {
    dispatch(fetchPermission());
  }, []);

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Role" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Box style={{ position: "relative" }}>
                  <ItemDetailViewSection
                    sectionName={`Permission for Role: ${at.Name}`}
                    userGroup={at.Permission}
                    lastItem
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default UserGroupView;
